import * as React from 'react';

import { ListProductionGroupsProps } from '../../components/list/production-groups';
import ListProductionGroup from '../../components/list/production-group';

const ListProductionGroupsView: React.StatelessComponent<ListProductionGroupsProps> = props => {
    return (
        <div className="stack">
                {
                    props.performanceGroups.map(pGroup => <ListProductionGroup key={`${pGroup.id}`} performanceGroup={pGroup} />)
                }
        </div>
    )
}

export default ListProductionGroupsView;